import React, { Fragment, PureComponent } from "react";
import { UISref } from "@uirouter/react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { SearchResultsTypes } from "../SearchResultsTypes";
import { formatDate } from "../../../../helpers/dateHelpers";
import { formatInvoice } from "../../../../helpers/invoiceHelpers";
import ResultsHighlighter from "./ResultsHighlighter";

class ShipmentsTile extends PureComponent {
  static propTypes = {
    onShowAllShipment: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    itemsWithAllShipmentShown: PropTypes.array,
    result: PropTypes.object,
    searchField: PropTypes.string,
    searchQuery: PropTypes.string,
    shipmentsShown: PropTypes.number,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    isMobile: false,
    itemsWithAllShipmentShown: [],
    result: {},
    searchField: "",
    searchQuery: "",
    shipmentsShown: 3,
    userMetadata: {}
  };

  get showAllShipments() {
    return this.props.itemsWithAllShipmentShown.includes(this.props.result.id);
  }

  get sortedShipments() {
    const { shipments = [] } = this.props.result;

    return _.sortBy(shipments, shipment => {
      const { carrierName = "", shipmentId = "", invoices = {}, vehicleId = "" } = shipment;

      let value = "";
      if (this.props.searchField === SearchResultsTypes.billsOfLading) {
        value = shipmentId;
      } else if (this.props.searchField === SearchResultsTypes.invoice) {
        value = formatInvoice(invoices);
      } else if (this.props.searchField === SearchResultsTypes.vehicle) {
        value = vehicleId;
      } else if (this.props.searchField === SearchResultsTypes.carrier) {
        value = carrierName;
      }

      return value.toLowerCase().includes(this.props.searchQuery.toLowerCase()) ? 0 : 1;
    });
  }

  get filteredShipments() {
    return !this.showAllShipments ? _.slice(this.sortedShipments, 0, this.props.shipmentsShown) : this.sortedShipments;
  }

  handleShowAllShipments = () => this.props.onShowAllShipment(this.props.result.id);

  render() {
    const isShipmentsEmpty = _.isEmpty(this.props.result.shipments);

    return (
      <div className="advanced-search__tile --large">
        {isShipmentsEmpty && <div className="advanced-search__list-row --no-result">{i18n.t("advancedSearch.noBillsOfLading")}</div>}

        {!isShipmentsEmpty && (
          <Fragment>
            {!this.props.isMobile && (
              <div className="advanced-search__list-row">
                <span className="advanced-search__label --flex-6">{i18n.t("advancedSearch.bol")}</span>
                <span className="advanced-search__label --flex-3">{i18n.t("advancedSearch.load")}</span>
                <span className="advanced-search__label --flex-3">{i18n.t("advancedSearch.mill")}</span>
                <span className="advanced-search__label --flex-8">{i18n.t("advancedSearch.shippedDate")}</span>
                <span className="advanced-search__label --flex-6">{i18n.t("advancedSearch.invoice")}</span>
                <span className="advanced-search__label --flex-5">{i18n.t("advancedSearch.vehicle")}</span>
                <span className="advanced-search__label --flex-7">{i18n.t("advancedSearch.carrier")}</span>
              </div>
            )}

            {this.filteredShipments.map(shipment => {
              const { invoices = {}, millOfOrigin = {} } = shipment;

              return (
                <div className="advanced-search__list-container --shipment" key={shipment.id}>
                  {this.props.isMobile && (
                    <div className="advanced-search__list-column">
                      <span className="advanced-search__label --flex-6">{i18n.t("advancedSearch.bol")}</span>
                      <span className="advanced-search__label --flex-3">{i18n.t("advancedSearch.load")}</span>
                      <span className="advanced-search__label --flex-3">{i18n.t("advancedSearch.mill")}</span>
                      <span className="advanced-search__label --flex-8">{i18n.t("advancedSearch.shippedDate")}</span>
                      <span className="advanced-search__label --flex-6">{i18n.t("advancedSearch.invoice")}</span>
                      <span className="advanced-search__label --flex-5">{i18n.t("advancedSearch.vehicle")}</span>
                      <span className="advanced-search__label --flex-7">{i18n.t("advancedSearch.carrier")}</span>
                    </div>
                  )}
                  <div className={classNames(this.props.isMobile ? "advanced-search__list-column" : "advanced-search__list-row", "--value")}>
                    {shipment.loadId ? (
                      <UISref
                        to="BillOfLadingList"
                        params={{
                          customerPOId: this.props.result.id,
                          loadId: shipment.loadUri,
                          shipmentId: shipment.id,
                          breadcrumbStack: ["BillOfLadingList"]
                        }}>
                        <span className="advanced-search__value --link --flex-6">
                          <ResultsHighlighter
                            className="advanced-search__highlight"
                            searchField={this.props.searchField}
                            searchQuery={this.props.searchQuery}
                            fieldName={SearchResultsTypes.billsOfLading}
                            textToHighlight={shipment.shipmentId}
                          />
                        </span>
                      </UISref>
                    ) : (
                      <span className="advanced-search__value --flex-6">
                        <ResultsHighlighter
                          className="advanced-search__highlight"
                          searchField={this.props.searchField}
                          searchQuery={this.props.searchQuery}
                          fieldName={SearchResultsTypes.billsOfLading}
                          textToHighlight={shipment.shipmentId}
                        />
                      </span>
                    )}

                    <span className="advanced-search__value --flex-3">{shipment.loadId}</span>
                    <span className="advanced-search__value --flex-3">{millOfOrigin.locationId}</span>
                    <span className="advanced-search__value --flex-8">
                      {formatDate(shipment.shippedDate, this.props.userMetadata.dateDisplayFormat) || "-"}
                    </span>

                    <span className="advanced-search__value --flex-6">
                      <ResultsHighlighter
                        className="advanced-search__highlight"
                        searchField={this.props.searchField}
                        searchQuery={this.props.searchQuery}
                        fieldName={SearchResultsTypes.invoice}
                        textToHighlight={formatInvoice(invoices)}
                      />
                    </span>
                    <span className="advanced-search__value --flex-5">
                      <ResultsHighlighter
                        className="advanced-search__highlight"
                        searchField={this.props.searchField}
                        searchQuery={this.props.searchQuery}
                        fieldName={SearchResultsTypes.vehicle}
                        textToHighlight={shipment.vehicleId}
                      />
                    </span>
                    <span className="advanced-search__value --flex-7">
                      <ResultsHighlighter
                        className="advanced-search__highlight"
                        searchField={this.props.searchField}
                        searchQuery={this.props.searchQuery}
                        fieldName={SearchResultsTypes.carrier}
                        textToHighlight={shipment.carrierName}
                      />
                    </span>
                  </div>
                </div>
              );
            })}

            <div className="advanced-search__list-row --button">
              {!this.showAllShipments &&
                this.sortedShipments.length > this.props.shipmentsShown && (
                  <button className="advanced-search__button --alternate" onClick={this.handleShowAllShipments}>
                    {i18n.t("advancedSearch.allBillsOfLading")}
                  </button>
                )}
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}
export default ShipmentsTile;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/Tiles/ShipmentsTile.js